import meter1 from "../assets/img/meter_90.svg";
import meter2 from "../assets/img/meter_75.svg";
import meter3 from "../assets/img/meter_70.svg";
import meter4 from "../assets/img/meter_80.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
                        <p>I am skilled in computer vision, NLP, machine learning, 3D modeling, parametric design, and interactive visual tools. I also have experience in hardware integration, Arduino sensors, and PCB design.</p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={meter1} alt="Skill1" />
                                <h5>Graphic & Animation</h5>
                            </div>
                            <div className="item">
                                <img src={meter2} alt="Skill2" />
                                <h5>Embedded Comms</h5>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="Skill3" />
                                <h5>Web & Program</h5>
                            </div>
                            <div className="item">
                                <img src={meter4} alt="Skill4" />
                                <h5>Product Modeling</h5>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Skill" />
    </section>
  )
}
